// extracted by mini-css-extract-plugin
module.exports = {"scheduleSection":"scheduleSection--QH1Qg","pagination":"pagination--8jm5m","title":"title--fUUlf","text":"text--5PI3b"};